import { render, staticRenderFns } from "./playCard.vue?vue&type=template&id=49685bc2&"
import script from "./playCard.vue?vue&type=script&lang=js&"
export * from "./playCard.vue?vue&type=script&lang=js&"
import style0 from "./playCard.vue?vue&type=style&index=0&id=49685bc2&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports